import React from "react";
import { CircularProgress } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import { usePaymentStatusPage } from "./usePaymentStatus";

const PaymentStatus = () => {
  const {
    searchParamLabels,
    transactionStatus,
    paymentFailed,
    payPerson,
    loading,
    handleOnBack,
    nextHandler,
  } = usePaymentStatusPage();

  const statusColor =
    transactionStatus === "Success" ? "success.main" : "error.main";

  return (
    <div>
      <div className="header-section">
        <p className="insurence-title-sec">
          Personal Accident Insurance
          <KeyboardArrowDownIcon />
        </p>
      </div>
      <Container
        style={{ marginTop: 10, marginBottom: 10 }}
        maxWidth="sm md lg"
      >
        <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
          <CardContent>
            <Grid container spacing={2}>
              {searchParamLabels?.map((param, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={5}>
                    <Typography>{param.label}</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong>{param.value}</strong>
                    </Typography>
                  </Grid>
                </React.Fragment>
              ))}
              <Grid item xs={5}>
                <Typography>Payment Status:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography color={statusColor}>
                  <strong>{transactionStatus || "Failed"}</strong>
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

      <div className="btn-sec position-fixed bottom-0">
        {loading ? (
          <div className="mx-auto">
            <CircularProgress size={48} sx={{ color: "red" }} />
          </div>
        ) : (
          <>
            <button
              className="reset-btn text-capitalize"
              onClick={handleOnBack}
            >
              Go Back
            </button>
            <button
              className="submitBtn text-capitalize "
              onClick={nextHandler}
              // disabled={isNext}
            >
              {paymentFailed
                ? "Pay Again"
                : payPerson === "customer"
                ? "Download Details"
                : "Next"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentStatus;
